<template>
<div>
	<p v-if="insideTable && readonly" style="margin:0">{{ localValue ? ((itemText ? localItems.find(c => c.id == localValue)[itemText] : localItems.find(c => c.id == localValue).accounting_no +'-' +localItems.find(c => c.id == localValue).name)|| emptyState ): emptyState}}</p>
	<bee-autocomplete
		v-else
		:context="context"
		:action-name="actionName"
		:items="localItems"
		:item-text="itemText"
		:item-value="itemValue ? itemValue : 'id'"
		:label="label"
		v-model="localValue"
		:readonly="readonly"
		:disabled="disabled"
		@change="$emit('change', $event)"
		@blur="$emit('blur', $event)"
		@keydown="$emit('keydown', $event)"
		@keypress="$emit('keypress', $event)"
		:insideTable="insideTable || dense"
		:rules="rules"
		@keydown-enter-prevent="$emit('keydown-enter-prevent')"
		@keydown-esc-prevent="$emit('keydown-esc-prevent')"
		@keydown.ctrl.down="$emit('keydown-ctrl-down')"
		:empty-state="emptyState"
		ref="BeeAccountAutocomplete"
		:clearable="clearable"
		:filter="customFilter"
		:hide-details="hideDetails">
		<template v-slot:selection="data">
			{{ itemText ? data.item[itemText] : data.item.accounting_no +'-'+ data.item.name }}
		</template>
		<template v-slot:item="data">
			{{ itemText ? data.item[itemText] : data.item.accounting_no + '-'+ data.item.name }}
			<v-spacer v-if="!!withBalance"></v-spacer>
			<bee-advanced-money-label :with-color="true" v-if="!!withBalance" :value="getBalance(data)" :show-zeros-values="true"></bee-advanced-money-label>
		</template>
	</bee-autocomplete>
</div>
</template>
<script>
export default {
props: ["rules", "value", "items", "label", "itemText", "insideTable", "dense", "readonly", "emptyState", "disabled", "clearable", "withBalance", "hideDetails", "context", "actionName", "itemValue"],
name: "BeeAccountAutocomplete",
computed: {
    localValue: {
		get: function () {
			return this.value;
		},
		set: function (value) {
			this.$emit("input", value);
		},
	},
	localItems: {
		get: function () {
			return this.items;
		},
		set: function (value) {
			this.items = value
		},
	},

	valid: {
		get() { return this.$refs.BeeAccountAutocomplete.valid },
		set(val) { this.$refs.BeeAccountAutocomplete.valid = val },
	},
	hasFocused: {
		get() { return this.$refs.BeeAccountAutocomplete.hasFocused },
		set(val) { this.$refs.BeeAccountAutocomplete.hasFocused = val },
	}
},
methods: {
    customFilter (item, queryText, itemText) {
		const filter = itemText ? itemText : item.accounting_no + '-' + item.name
		const searchText = queryText.toLocaleLowerCase()
		return ( 
			filter.toLocaleLowerCase().indexOf(searchText) > -1 
		)
    },
	getBalance(data){
		return data.item?.account_statement_summary
	},
	
	focus() {
		this.$refs.BeeAccountAutocomplete.focus();
	},
	validate() {
		return this.$refs.BeeAccountAutocomplete.validate();
	},
	resetValidation() {
		this.$refs.BeeAccountAutocomplete.resetValidation();
	}
},
};
</script>
<style>
</style>